import { ReactElement, useEffect, useState } from "react";
import FilterComponentBase from "../../../components/filterComponentBase";
import { useFetch } from "../../../system/useFetch";
import { IContentAreaProps, IEAFProduction, IFilterData, IProduction, IState } from "../../../types";
import { useSelector } from "react-redux";
import { Alert, Paper, IconButton } from "@mui/material";
import ProductionHeader from "./productionHeader";
import ProductionChart from "./productionChart";
import SkeletonView from "../../../components/skeletonView";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProductionTab from "./productionTab";
import useDimensions from "../../../system/useDimensions";

const pollInterval = 300000;  // 5 min

const ProductionReportEAF = ({ parentSize }: IContentAreaProps): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const [productionData, setProductionData] = useState<IEAFProduction[] | null>(null);
  const [open, setOpen] = useState(false);
  const [ref, dimensions] = useDimensions<HTMLDivElement>();
  const { loading, error, data: response } = useFetch<IProduction[]>(
    {
      module: "production",
      query: "getProductionGanttByFilter",
      payload: { ...filter.remote }
    }, filter.local.mode === "REAL_TIME" ? pollInterval : 0);

  useEffect(() => {
    if (!response) {
      setProductionData(null);

      return;
    }

    const list: IEAFProduction[] = [];

    response.forEach(row => {
      row.productionMachines.forEach(machineData => list.push(machineData as IEAFProduction));
    });

    setProductionData(list.length > 0 ? list : null);
  }, [response]);

  return (
    <div className="display-grid" style={{ ...parentSize, maxHeight: parentSize.height, position: "relative", gridTemplateRows: "auto auto 1fr" }}>
      <FilterComponentBase loading={loading}/>
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !productionData && <Alert severity="warning">No Data to Display.</Alert>}

      { productionData &&
        <Paper className="mb-1 flex-grow-0 display-flex-column p-1" style={{ position: "relative" }}>
          <div className="display-flex-row align-items-center" style={{ position: "relative", left: 0, top: 0 }}>
            <IconButton onClick={() => setOpen(!open)} size={"small"} className="mr-1">
              {open
                ? <ExpandLessIcon fontSize="inherit" fontWeight="bold"/>
                : <ExpandMoreIcon fontSize="inherit" fontWeight="bold"/>
              }
            </IconButton>
            {!open && <strong>General</strong>}
          </div>

          {open && <ProductionHeader productionData={productionData}/>}
          { open && <ProductionChart productionData={productionData} />}
        </Paper>
      }

      <div className="grid-cell" ref={ref}>
        {productionData && <ProductionTab productionData={productionData} parentSize={dimensions} />}
      </div>
    </div>
  );
};

export default ProductionReportEAF;
